export const MANUFACTURER_MANUALS_API_URL = 'ui/partner/manuals';
